import {reset} from 'redux-form'
import {toastr} from 'react-redux-toastr';
import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";
import {ITEMS_PER_PAGE} from '../components/common/CustomPagination'
import * as spinnerActions from './spinnerActions';


export function getDefaultJobState() {
    return {type: types.GET_DEFAULT_JOB_STATE};
}

export function loadJobs(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.all('jobs?limit='+ITEMS_PER_PAGE+'&offset='+(ITEMS_PER_PAGE * (page - 1)), sortParams)
            .then((data)  => {
                dispatch(loadJobsSuccess(data));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function loadJobsSuccess(jobs) {
    return {type: types.LOAD_JOBS_SUCCESS, jobs};
}

export function getJob(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('jobs', id)
            .then((data)  => {
                dispatch(loadJobSuccess(data));
            });
    };
}

export function loadJobSuccess(job) {
    return {type: types.LOAD_JOB_SUCCESS, job};
}

export function cloneJob(jobId, page) {
    return function (dispatch) {
        return PrivateAPIResource.create(`jobs/${jobId}/clone`)
            .then((data) => {
                dispatch(loadJobs(page));
                dispatch(cloneJobSuccess());
            })
            .catch(err => {
                throw err;
            });
    }
}

export function cloneJobSuccess() {
    toastr.success('Job has been successfully cloned.');
    return {type: types.CLONE_JOB_SUCCESS};
}

export function showJobDeleteModal() {
    return {type: types.SHOW_JOB_DELETE_MODAL, status: true};
}

export function hideJobDeleteModal() {
    return {type: types.SHOW_JOB_DELETE_MODAL, status: false};
}

export function deleteJob(jobId, page) {
    return function (dispatch) {
        return PrivateAPIResource.remove('jobs', jobId)
            .then(response => {
                dispatch(loadJobs(page));
                dispatch(deleteJobSuccess());
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function deleteJobSuccess() {
    toastr.success('Job has been successfully deleted.');
    return {type: types.DELETE_JOB_SUCCESS};
}

export function loadJobRegions() {
    return function (dispatch) {
        return PrivateAPIResource.all('jobs/regions')
            .then((data)  => {
                dispatch(loadJobRegionsSuccess(data));
            });
    }
}

export function loadJobRegionsSuccess(regions) {
    return {type: types.LOAD_JOB_REGIONS_SUCCESS, regions: regions};
}

export function loadJobCategories() {
    return function (dispatch) {
        return PrivateAPIResource.all('jobs/categories')
            .then((data)  => {
                dispatch(loadJobCategoriesSuccess(data));
            });
    }
}

export function loadJobCategoriesSuccess(categories) {
    return {type: types.LOAD_JOB_CATEGORIES_SUCCESS, categories: categories};
}

export function loadJobWorkingTimes() {
    return function (dispatch) {
        return PrivateAPIResource.all('jobs/working-times')
            .then((data)  => {
                dispatch(loadJobWorkingTimesSuccess(data));
            });
    }
}

export function loadJobWorkingTimesSuccess(workingTimes) {
    return {type: types.LOAD_JOB_WORKING_TIMES_SUCCESS, workingTimes: workingTimes};
}

export function createJob(data) {
    return function (dispatch) {
        return PrivateAPIResource.create('jobs', data).then((data)  => {
            dispatch(createJobSuccess(data));
            dispatch(reset('job'));
        });
    }
}

export function createJobSuccess() {
    toastr.success('Job has been successfully created.');
    return {type: types.CREATE_JOB_SUCCESS}
}

export function updateJob(jobId, data) {
    return function (dispatch) {
        return PrivateAPIResource.update('jobs', jobId, data).then((data)  => {
            dispatch(updateJobSuccess(data));
        });
    }
}

export function updateJobSuccess(data) {
    toastr.success('Job has been successfully updated.');
    return {type: types.UPDATE_JOB_SUCCESS}
}


// WEBPACK FOOTER //
// ./web/src/actions/jobActions.js